// CORE-1910 — Idempotency-Key для неидемпотентных запросов.
//
// Браузер отдаёт `TypeError` («Load failed» в Safari) не только когда запрос
// не дошёл, но и на ответ без CORS-заголовков — 502/503/504 шлюза или эджа, —
// в том числе когда бэкенд запрос уже выполнил. Поэтому слепой повтор POST
// создаёт дубль (CORE-1905: вторая Live-сессия). С ключом повтор безопасен:
// бэкенд (`[Idempotent]`) хранит ответ первого запроса и на повтор отдаёт его
// же, а пока первый выполняется — 409.
//
// Правило для обёрток повтора (apiFallback, netResilience): POST/PUT/PATCH/
// DELETE повторяются при транспортном отказе ТОЛЬКО с этим заголовком. Один
// ключ — одно действие пользователя: его генерирует вызов API (createRoom и
// т. п.), и тот же ключ едет во всех повторах и в фолбэке на api-ru, потому что
// обёртки переотправляют те же `init`/`Request`.

export const IDEMPOTENCY_KEY_HEADER = 'Idempotency-Key';

/** Новый ключ на одно действие пользователя. */
export function newIdempotencyKey(): string {
  const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
  if (c?.randomUUID) return c.randomUUID();
  // Старые движки без randomUUID: уникальности на пользователя хватает —
  // сервер ищет ключ в паре с userId, методом и путём.
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

function headerIn(headers: unknown): boolean {
  if (!headers) return false;
  const name = IDEMPOTENCY_KEY_HEADER.toLowerCase();
  if (typeof (headers as Headers).get === 'function') {
    return !!(headers as Headers).get(IDEMPOTENCY_KEY_HEADER);
  }
  if (Array.isArray(headers)) {
    return headers.some((pair) => Array.isArray(pair) && String(pair[0]).toLowerCase() === name && !!pair[1]);
  }
  if (typeof headers === 'object') {
    return Object.entries(headers as Record<string, unknown>)
      .some(([k, v]) => k.toLowerCase() === name && !!v);
  }
  return false;
}

/**
 * Несёт ли запрос Idempotency-Key — в `init.headers` (объект, массив пар или
 * `Headers`) или в заголовках `Request`.
 */
export function hasIdempotencyKey(input: unknown, init?: RequestInit): boolean {
  if (headerIn(init?.headers)) return true;
  if (input && typeof input === 'object' && 'headers' in (input as Request)) {
    return headerIn((input as Request).headers);
  }
  return false;
}
